import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { u as o } from "./index-6a632112.mjs";
import { Q as b, s as a, b as m, d as c, e as p, a as h } from "./themes-5f0b3c3d.mjs";
import { l as g } from "./lineHeights-72d3110c.mjs";
import { z as x } from "./zIndices-d07533f3.mjs";
import { a as y, b as D } from "./superScript-393c70dc.mjs";
import "react";
import { Menu as v } from "./menu.js";
import { Disclosures as C } from "./disclosure.js";
import { CloseButton as L } from "./closeButton.js";
import { h as f } from "./hTag-40b23797.mjs";
import { m as w, A as S } from "./index-c8707610.mjs";
import "./moreVertical-dc2e97a2.mjs";
import "./types-b577bf77.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./accessibility.js";
import "./tslib.es6-59e1c9d8.mjs";
const W = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, i = {
  LARGE: "700px",
  MEDIUM: "500px",
  SMALL: "400px"
}, A = o(w.div)`
  ${y()}
  ${D()}
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  height: 100%;
  z-index: ${x.modal};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
  background-color: ${(e) => e.theme.components.drawer.backgroundColor};
  width: 100%;
  right: ${({ placement: e }) => e === "left" ? "0" : "calc(max(700px * -1, -100%))"};
  max-width: unset;
  @media ${b.tabletAndUp} {
    ${({ size: e, placement: r }) => {
  switch (e) {
    case "large":
      return `
        max-width: ${i.LARGE};
        width: 100%;
        ${r === "right" ? `right: calc(max(${i.LARGE} * -1, -100%))` : "left: 0"};
        `;
    case "medium":
      return `
        max-width: ${i.MEDIUM};
        width: 100%;
        ${r === "right" ? `right: calc(max(${i.MEDIUM} * -1, -100%))` : "left: 0"};
        `;
    case "small":
      return `
        max-width: ${i.SMALL};
        width: 100%;
        ${r === "right" ? `right: calc(max(${i.SMALL} * -1, -100%))` : "left: 0"};
        `;
    default:
      return "width: 280px;";
  }
}}
  }
`, E = o.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 20, 46, 0.3);
  z-index: ${x.overlay};
`, M = o.div`
  min-height: 80px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: ${a["4x"]} ${a["6x"]};
  border-bottom: ${m["1x"]} solid
    ${(e) => e.theme.components.drawer.borderColorDefault};
  color: ${(e) => e.theme.components.drawer.titleColor};
`, z = o.div`
  display: flex;
  max-height: 83px;
  border-top: ${m["1x"]} solid
    ${(e) => e.theme.components.drawer.borderColorDefault};
  justify-content: flex-end;
  align-items: center;
  padding: ${a["4x"]} ${a["6x"]};
`, k = o.div`
  ${W()}
  flex-grow: 1;
  overflow-y: scroll;
  padding: ${a["6x"]};
  color: ${(e) => e.theme.components.drawer.titleColor};
`, R = o.span`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: auto;
`, T = o.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`, I = o.div`
  margin-top: ${a["1x"]};
  margin-right: ${a["2x"]};
`, U = o(f)`
  font-family: ${c.eyebrow};
  font-weight: ${p.medium.L.fontWeight};
  font-size: ${h.medium};
  line-height: ${g.large};
  color: ${(e) => e.theme.components.drawer.titleColor};
`, j = o(f)`
  font-family: ${c.eyebrow};
  font-weight: ${p.regular.S.fontWeight};
  font-size: ${h.xsmall};
  line-height: ${g.small};
  color: ${(e) => e.theme.components.drawer.subtitleColor};
`, H = o.span`
  margin-right: ${a["4x"]};
`, de = ({
  // drawerTitle = 'Drawer title',
  titleProp: e = { title: "Drawer title", headingLevel: "h1" },
  subTitleProp: r,
  drawerMenuItems: n,
  drawerBadge: s,
  onClose: l
}) => /* @__PURE__ */ d(M, { "aria-label": "drawer-header", children: [
  /* @__PURE__ */ d(R, { children: [
    /* @__PURE__ */ t(U, { "aria-label": "drawer-title", as: e.headingLevel, children: e.title }),
    r && /* @__PURE__ */ t(
      j,
      {
        "aria-label": "drawer-subtitle",
        as: r?.headingLevel || "h2",
        children: r.subTitle
      }
    )
  ] }),
  /* @__PURE__ */ d(T, { children: [
    s && /* @__PURE__ */ t(H, { "aria-label": "drawer-badge", children: s }),
    n && /* @__PURE__ */ t(I, { children: /* @__PURE__ */ t(v, { "aria-label": "drawer-menu", children: n }) }),
    /* @__PURE__ */ t(
      L,
      {
        ariaLabel: "drawer-close-btn",
        onClick: l,
        size: "medium"
      }
    )
  ] })
] }), se = ({
  children: e
}) => /* @__PURE__ */ t(z, { "aria-label": "drawer-footer", children: e }), me = ({ children: e, disclosures: r }) => /* @__PURE__ */ d(k, { "aria-label": "drawer-content", children: [
  e,
  r && /* @__PURE__ */ t(
    C,
    {
      disclosureContent: r?.disclosureContent,
      id: r?.id,
      className: r?.className,
      disclosureTitleColor: r?.disclosureTitleColor,
      style: r?.style
    }
  )
] }), G = {
  open: { x: "-100%" },
  closed: { x: 0 }
}, N = {
  open: { x: 0 },
  closed: { x: "-100%" }
}, ce = ({
  isOpen: e,
  size: r = "medium",
  placement: n = "right",
  children: s,
  onClose: l
}) => {
  const $ = (u) => {
    u.key === "Escape" && l && l();
  };
  return /* @__PURE__ */ t(S, { children: e && /* @__PURE__ */ d(w.div, { className: "overlay", children: [
    e && /* @__PURE__ */ t(E, { "aria-label": "drawer-overlay", onClick: l }),
    /* @__PURE__ */ t(
      A,
      {
        initial: "closed",
        animate: e ? "open" : "closed",
        exit: "closed",
        variants: n === "right" ? G : N,
        transition: { duration: 0.3 },
        role: "dialog",
        size: r,
        isOpen: e,
        placement: n,
        onKeyDown: $,
        children: s
      }
    )
  ] }) });
};
export {
  ce as Drawer,
  me as DrawerContent,
  se as DrawerFooter,
  de as DrawerHeader
};
